import angular  from 'angular'

import component from './manage-purchase-topblock.component'

let module = angular.module('managePurchaseTopblock', [])

.component('managePurchaseTopblock', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/common/manage-purchase-topblock/index.js